var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1300" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "py-0" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline ma-0" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [_c("v-icon", [_vm._v("schedule")]), _vm._v(" Marcados ")],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c("v-flex", { attrs: { md6: "", xs12: "" } }, [
                            _c("strong", { staticClass: "blue--text" }, [
                              _vm._v("DEPENDENCIA: ")
                            ]),
                            _vm._v(
                              _vm._s(_vm.form.nombre_unidad) + "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("strong", { staticClass: "blue--text" }, [
                              _vm._v("SERVIDOR PÚBLICO: ")
                            ]),
                            _vm._v(
                              _vm._s(_vm.form.nombres) +
                                " " +
                                _vm._s(_vm.form.ap_paterno) +
                                " " +
                                _vm._s(_vm.form.ap_materno) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", "justify-space-between": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { grow: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido",
                                attrs: {
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  color: "#16516f",
                                  label: "Fecha desde"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.mostrarMarcadosOriginalesBandera(
                                      _vm.type
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.fecha_desde,
                                  callback: function($$v) {
                                    _vm.fecha_desde = $$v
                                  },
                                  expression: "fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { grow: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido",
                                attrs: {
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  color: "#16516f",
                                  label: "Fecha hasta"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.mostrarMarcadosOriginalesBandera(
                                      _vm.type
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.fecha_hasta = $$v
                                  },
                                  expression: "fecha_hasta"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "#812595",
                                    dark: "",
                                    icon: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.verReporte()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("picture_as_pdf")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "justify-space-between": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center",
                              attrs: { shrink: "" }
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "text-field-reducido",
                                attrs: { label: "Ver marcados procesados" },
                                on: {
                                  change: function($event) {
                                    return _vm.mostrarMarcadosOriginalesBandera(
                                      _vm.type
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.type,
                                  callback: function($$v) {
                                    _vm.type = $$v
                                  },
                                  expression: "type"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { shrink: "" } }, [
                            this.type == true
                              ? _c("p", [
                                  _c("strong", [_vm._v("TOTAL ATRASOS:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.total_atrasos) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pa-0" },
            [
              _vm.type == true
                ? _c("v-data-table", {
                    staticClass: "elevation-1 tabla-comprimida-light",
                    attrs: {
                      headers: _vm.headers2,
                      items: _vm.lista_tipificados,
                      "no-data-text": _vm.loading2
                        ? "Cargando..."
                        : "No se tiene registros",
                      "disable-initial-sort": true,
                      loading: _vm.loading2,
                      "item-key": "index",
                      "rows-per-page-items": [
                        5,
                        10,
                        20,
                        { text: "Todos", value: -1 }
                      ]
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.dia))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(props.item.fecha_marcado) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.atraso))
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-xs-center" },
                                [
                                  props.item.loading != true
                                    ? _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "align-center": "",
                                            "justify-space-between": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "table",
                                            { staticClass: "table-marcado" },
                                            [
                                              _c("tr", [
                                                _c("th", [_vm._v("Horario")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("Marcado")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("Atraso")]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v("Descripción")
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(
                                                props.item.marcados,
                                                function(marcado) {
                                                  return _c(
                                                    "tr",
                                                    {
                                                      key:
                                                        marcado.id_control_asistencia,
                                                      style:
                                                        marcado.atraso > 0
                                                          ? "background:rgb(219, 62, 177,0.3"
                                                          : marcado.tipo_marcado ==
                                                            "I"
                                                          ? "background:rgb(252, 76, 2,0.3"
                                                          : ""
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            width: "15%"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              marcado.horario
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            width: "15%"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                marcado.hora_marcada
                                                                  ? marcado.hora_marcada
                                                                  : "-"
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            width: "15%"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              marcado.atraso
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            width: "55%"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              marcado.descripcion_caso
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              props.item.marcados.length == 0
                                                ? _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "4" }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "NO CUENTA CON MARCADOS"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  props.item.loading == true
                                    ? _c("v-progress-circular", {
                                        attrs: {
                                          width: 5,
                                          size: 70,
                                          color: "green",
                                          indeterminate: ""
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "#00B2A9",
                                            dark: "",
                                            icon: "",
                                            loading: props.item.loading == true
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.actualizaTipificaDia(
                                                props.item
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("update")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Actualizar marcados")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3460296535
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type == false
                ? _c("v-data-table", {
                    staticClass: "elevation-1 tabla-comprimida-light",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.lista,
                      "no-data-text": _vm.loading
                        ? "Cargando..."
                        : "No se tiene registros",
                      "disable-initial-sort": true,
                      loading: _vm.loading,
                      "item-key": "index",
                      "rows-per-page-items": [
                        20,
                        40,
                        { text: "Todos", value: -1 }
                      ]
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.dia))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.fecha))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.hora))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3616128802
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7199e8ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7199e8ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/pasantes/dialogs/VerMarcados.vue
// module id = null
// module chunks = 